export default __webpack_public_path__ + "static/media/manage_providers_employees.7be05566.svg";